var map = {
	"./2022_tc_winner.jpg": "ea23",
	"./2023_banquet.png": "6795",
	"./Bear-Creek-east.png": "29f1",
	"./Bear-Creek-west.png": "87e9",
	"./Cowboys-gc.png": "7058",
	"./Coyote-Ridge.jpeg": "2112",
	"./Earlywine.png": "1305",
	"./Firewheel-bridges.jpeg": "d9f6",
	"./Fossil-Creek.jpeg": "9c20",
	"./Fossil-Creek.png": "7452",
	"./Heritage-Ranch.jpeg": "1af2",
	"./Indian-Creek.jpg": "e5b4",
	"./Iron-Horse.jpeg": "c3dd",
	"./Irving-Golf-Club.png": "b774",
	"./Luna-Vista.jpeg": "8aea",
	"./Pecan-Hollow.jpeg": "4513",
	"./Plantation.jpeg": "bf47",
	"./Ridgeview-Ranch.png": "c212",
	"./Rio-Secco.jpg": "f5f6",
	"./Riverside.png": "95cf",
	"./Sherrill-Park.jpeg": "f6d1",
	"./Tangle-Ridge.jpeg": "d797",
	"./Texas-Star.png": "6042",
	"./Thorntree.png": "19a9",
	"./TierraVerde.png": "f7fd",
	"./Twin-Creek.png": "e996",
	"./Tx_Cup_2022_4.png": "7ac9",
	"./Waterchase.jpeg": "04af",
	"./Watters-Creek.png": "20af",
	"./West-Ridge.jpeg": "d321",
	"./Woodbridge.jpeg": "8d13",
	"./buffalo-creek.png": "7bc1",
	"./cedar-crest.jpeg": "abb7",
	"./cedar-crest.png": "c193",
	"./default-image.png": "b30a",
	"./default_banquet.png": "a39b",
	"./dfwvga-banquet-2.png": "d50ad",
	"./lincoln-okc.jpeg": "b9ea",
	"./lincoln-okc.png": "2ad0",
	"./pebble-1.jpeg": "7eea",
	"./pebble-beach.png": "11b6",
	"./revere.jpg": "77bb",
	"./stevens-park.jpeg": "bf73",
	"./stevens-park.png": "773a",
	"./tournament_flyer copy.png": "044a",
	"./tournament_flyer.png": "c96a",
	"./waterview.png": "0f2a",
	"./winstar-redbud.png": "d0aa",
	"./winstar-scissortail.png": "e6e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9431";